import React from 'react'
import propTypes from 'prop-types'
import moment from 'moment'

import Button from './Button'

export function ESignatureStatus({
  documentInfo,
  viewContractAuditTrail,
  viewContractCertificate,
  lease,
}) {
  // Maps docusign role names to our internal lessee names
  const lesseeMap = {
    main_lessee: lease.main_lessee_name,
    co_lessee_1: lease.co_lessees?.co_lessee_name_1,
    co_lessee_2: lease.co_lessees?.co_lessee_name_2,
    co_lessee_3: lease.co_lessees?.co_lessee_name_3,
  }

  const sentDate = new Date(documentInfo.sentDateTime).getTime() / 1000

  const docName = documentInfo.envelopeDocuments[0].name

  const isCompleted = documentInfo.status === 'completed'

  const recipientMarkup = documentInfo.recipients.signers.map(recipient => {
    const key = recipient.recipientIdGuid

    const dateFinalized = new Date(recipient.signedDateTime).getTime() / 1000

    const docusignLesseeName = lesseeMap[recipient.roleName]

    return (
      <div className='mb-1' key={key}>
        <div>
          <span className='signature-field-title'>Lessee</span>
          {` - ${docusignLesseeName}`}
        </div>
        <div>
          <span className='signature-field-title'>Email</span>
          {` - ${recipient.email}`}
        </div>
        <div>
          <span className='signature-field-title'>Status</span>
          {` - ${recipient.status}`}
        </div>
        {isCompleted && (
          <div>
            <span className='signature-field-title'>Date Finalized</span>
            {` - ${moment.unix(dateFinalized).format('MMMM DD, YYYY h:mm A')}`}
          </div>
        )}
      </div>
    )
  })

  return (
    <div>
      <div>
        <span className='signature-field-title'>Status</span>
        {` - ${documentInfo.status}`}
      </div>
      <div>
        <span className='signature-field-title'>Date sent</span>
        {` -
        ${moment.unix(sentDate).format('MMMM DD, YYYY h:mm A')}`}
      </div>
      <div>
        <span className='signature-field-title'>Name of Document</span>
        {` - ${docName}`}
      </div>
      {isCompleted && (
        // TODO: should this only be available to admins?
        <>
          <div style={{ margin: '20px 0 10px 0' }}>
            <Button onClick={viewContractAuditTrail}>
              View Contract Audit Trail
            </Button>
          </div>

          <div style={{ margin: '20px 0 10px 0' }}>
            <Button onClick={viewContractCertificate}>
              View Signed Contract Certificate
            </Button>
          </div>
        </>
      )}
      <div className='pt-1'>
        <b style={{ textDecoration: 'underline' }}>Lessee Signature Status</b>
      </div>
      {recipientMarkup}
    </div>
  )
}

ESignatureStatus.propTypes = {
  documentInfo: propTypes.object,
  viewContractAuditTrail: propTypes.func,
  viewContractCertificate: propTypes.func,
  lease: propTypes.object,
}
